import React, { useState, useEffect } from "react";
import SubmissionSuccess from "../pages/Submission";
import FormBuilder4 from "./FormBuilder4";
function Survey({ data, timerDone, id, userLocation }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [surveyAnswers, setSurveyAnswers] = useState(null);

  async function getAnswers(id) {
    let headersList = {
      Accept: "*/*",

      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      id: id,
    });

    let response = await fetch(
      "https://foshizi.herokuapp.com/api/getAnswersBySurveyId",
      {
        method: "POST",
        body: bodyContent,
        headers: headersList,
      }
    );

    let data = await response.text();
    setSurveyAnswers(JSON.parse(data));
    console.log(surveyAnswers);
    console.log(JSON.parse(data));
  }

  useEffect(() => {
    getAnswers(id);
    if (timerDone) {
      console.log("timer is done");
      setIsSubmitted(true);
    }
  }, [timerDone]);

  const handleSubmit = async (event, answers) => {
    event.preventDefault();
    console.log(answers);
    let isSubmitted = false; // add a variable to track if the user has already submitted the survey

    surveyAnswers.forEach((answer) => {
      if (answer.responder_email === answers["10000"]) {
        alert("You have already submitted this survey");
        setIsSubmitted(true);
        isSubmitted = true; // set the variable to true if the user has submitted the survey

        return;
      }
    });

    if (isSubmitted) {
      return; // stop the function execution if the user has submitted the survey
    }
    // Send the answers to the server
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      survey_id: id,
      location: `${userLocation}`,
      responder_email: answers["10000"],
      date_created: new Date(),
      data: answers,
    });

    let response = await fetch(
      "https://foshizi.herokuapp.com/api/insertAnswer",
      {
        method: "POST",
        body: bodyContent,
        headers: headersList,
      }
    );

    let data = await response.text();
    console.log(data);

    // Set isSubmitted to true after sending the data
    // Define the variable 'id' with the desired value

    // Retrieve the existing survey IDs from localStorage
    var surveyIds = localStorage.getItem("surveyId");

    // If survey IDs exist in localStorage, parse the JSON string into an array
    if (surveyIds) {
      surveyIds = JSON.parse(surveyIds);
    } else {
      // If no survey IDs exist in localStorage, create an empty array
      surveyIds = [];
    }

    // Add the new 'id' to the array
    surveyIds.push(id);

    // Convert the updated array to a JSON string and store it back in localStorage
    localStorage.setItem("surveyId", JSON.stringify(surveyIds));

    setIsSubmitted(true);
  };

  console.log(data);
  return (
    <>
      {!isSubmitted ? (
        <FormBuilder4 questions={data} handleSubmit={handleSubmit} />
      ) : (
        <SubmissionSuccess />
      )}
    </>
  );
}

export default Survey;
